import Vue from 'vue'
import i18n from '@/plugins/i18n.js'
import { URL_STATIC_PAGES } from '@/constants/urls.js'
import { STATIC_PAGES_TAGS } from '@/constants/business.js'
import { STATIC_PAGES, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const pageContents = () => {
  const page = {}
  Object.keys(STATIC_PAGES_TAGS).forEach(tag => {
    tag = `${STATIC_PAGES_TAGS[tag]}_${i18n.locale.toLowerCase()}`
    page[tag] = null
  })
  return page
  //  {
  //   static_docs_tariffs_ru: null,
  //   static_docs_tariffs_en: null,
  //   static_docs_org_registration_ru: null,
  //   static_docs_org_registration_en: null,
  //   static_docs_user_registration_ru: null,
  //   static_docs_user_registration_en: null,
  //   static_docs_guides_ru: null,
  //   static_docs_guides_en: null,
  //   static_docs_requisites_ru: null,
  //   static_docs_requisites_en: null,
  //   static_main_admin_ru: null,
  //   static_main_admin_en: null,
  //   static_main_ru: null,
  //   static_main_en: null,
  //   static_digital_signature_ru: null,
  //   static_digital_signature_en: null,
  //   static_skzi_ru: null,
  //   static_skzi_en: null,
  //   static_support_ru: null,
  //   static_support_en: null
  // }
}

const state = {
  [STATIC_PAGES.STATE.PAGES]: [],
  [STATIC_PAGES.STATE.STATIC_FILES]: [],
  [STATIC_PAGES.STATE.CURRENT_STATIC_PAGE]: null,
  [STATIC_PAGES.STATE.CURRENT_STATIC_PAGE_CONTENT]: pageContents()
}

const actions = {
  async [STATIC_PAGES.ACTIONS.GET_ALL_STATIC_PAGES] ({ commit, dispatch }) {
    const model = {
      url: `${Vue.getBusinessHost()}${URL_STATIC_PAGES}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(STATIC_PAGES.MUTATIONS.GET_ALL_STATIC_PAGES, resp.data)
  },
  async [STATIC_PAGES.ACTIONS.GET_STATIC_FILES] ({ commit, dispatch }) {
    const model = {
      url: `${Vue.getBusinessHost()}/staticFiles?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(STATIC_PAGES.MUTATIONS.GET_STATIC_FILES, resp.data)
  },
  async [STATIC_PAGES.ACTIONS.UPLOAD_STATIC_FILE] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getBusinessHost()}/staticFiles`,
      model: model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [STATIC_PAGES.ACTIONS.EDIT_STATIC_FILE] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getBusinessHost()}/staticFiles/${model.fileId}`,
      model: model.file
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [STATIC_PAGES.ACTIONS.DELETE_STATIC_FILE] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getBusinessHost()}/staticFiles/${model.fileId}`
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.DELETE_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [STATIC_PAGES.ACTIONS.GET_FULL_PAGE_INFO] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_STATIC_PAGES}/${model.tag}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(STATIC_PAGES.MUTATIONS.GET_FULL_PAGE_INFO, resp.data)
  },
  async [STATIC_PAGES.ACTIONS.GET_PUBLISHED_PAGE_CONTENT] ({ commit, dispatch }, model) {
    const tag = model.tag
    model = {
      url: `${Vue.getBusinessHost()}${URL_STATIC_PAGES}/${model.tag}/published?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(STATIC_PAGES.MUTATIONS.GET_PUBLISHED_PAGE_CONTENT, {
      tag,
      content: resp.data
    })
  },
  async [STATIC_PAGES.ACTIONS.EDIT_PAGE_CONTENT] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_STATIC_PAGES}/${model.tag}/content`,
      model: model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [STATIC_PAGES.ACTIONS.EDIT_PAGE] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_STATIC_PAGES}/${model.tag}`,
      model: model.page
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [STATIC_PAGES.ACTIONS.DELETE_PAGE] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_STATIC_PAGES}/${model.tag}`
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.DELETE_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [STATIC_PAGES.ACTIONS.ADD_PAGE] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_STATIC_PAGES}`,
      model: model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [STATIC_PAGES.ACTIONS.PUBLISH_PAGE_CONTENT] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_STATIC_PAGES}/${model.tag}/publish`
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [STATIC_PAGES.ACTIONS.RESET_PAGE_CONTENT] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_STATIC_PAGES}/${model.tag}/restore`
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [STATIC_PAGES.ACTIONS.CLEAR_ALL_STATIC_PAGES] ({ commit }) {
    commit(STATIC_PAGES.MUTATIONS.CLEAR_ALL_STATIC_PAGES)
  },
  async [STATIC_PAGES.ACTIONS.CLEAR_FULL_PAGE_INFO] ({ commit }) {
    commit(STATIC_PAGES.MUTATIONS.CLEAR_FULL_PAGE_INFO)
  },
  async [STATIC_PAGES.ACTIONS.CLEAR_PUBLISHED_PAGE_CONTENT] ({ commit }) {
    commit(STATIC_PAGES.MUTATIONS.CLEAR_PUBLISHED_PAGE_CONTENT)
  },
  async [STATIC_PAGES.ACTIONS.CLEAR_STATIC_FILES] ({ commit }) {
    commit(STATIC_PAGES.MUTATIONS.CLEAR_STATIC_FILES)
  }
}

const mutations = {
  [STATIC_PAGES.MUTATIONS.GET_ALL_STATIC_PAGES] (state, pages) {
    state[STATIC_PAGES.STATE.PAGES] = pages
  },
  [STATIC_PAGES.MUTATIONS.GET_STATIC_FILES] (state, files) {
    state[STATIC_PAGES.STATE.STATIC_FILES] = files
  },
  [STATIC_PAGES.MUTATIONS.CLEAR_STATIC_FILES] (state) {
    state[STATIC_PAGES.STATE.STATIC_FILES] = []
  },
  [STATIC_PAGES.MUTATIONS.GET_FULL_PAGE_INFO] (state, page) {
    state[STATIC_PAGES.STATE.CURRENT_STATIC_PAGE] = page
  },
  [STATIC_PAGES.MUTATIONS.CLEAR_FULL_PAGE_INFO] (state) {
    state[STATIC_PAGES.STATE.CURRENT_STATIC_PAGE] = null
  },
  [STATIC_PAGES.MUTATIONS.GET_PUBLISHED_PAGE_CONTENT] (state, page) {
    state[STATIC_PAGES.STATE.CURRENT_STATIC_PAGE_CONTENT][page.tag] = page.content
  },
  [STATIC_PAGES.MUTATIONS.CLEAR_PUBLISHED_PAGE_CONTENT] (state) {
    state[STATIC_PAGES.STATE.CURRENT_STATIC_PAGE_CONTENT] = pageContents()
  },
  [STATIC_PAGES.MUTATIONS.CLEAR_ALL_STATIC_PAGES] (state) {
    state[STATIC_PAGES.STATE.PAGES] = []
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
